import {User} from "@/entities/user";
import useBodyClass from "@/Hooks/useBodyClass"; // Legacy
import useGlobalUserDataLayer from "@/Hooks/Effects/Analytics/useGlobalUserDataLayer"; // Legacy
import usePageChangesForYaMetrica from "@/Hooks/Effects/Analytics/usePageChangesForYaMetrica"; // Legacy
import useCloseModalWindows from "@/Hooks/Effects/Modals/useCloseModalWindows"; // Legacy
import useShowWheelOfFortune from "@/Hooks/Effects/Modals/useShowWheelOfFortune"; // Legacy
import useShowContinueApplication from "@/Hooks/Effects/Modals/useShowContinueApplication"; // Legacy
import useShowDiscountOnFirstOrder from "@/Hooks/Effects/Modals/useShowDiscountOnFirstOrder"; // Legacy
import useShowGiftCalendar from "@/Hooks/Effects/Modals/useShowGiftCalendar"; // Legacy
import useShowSecretSanta from "@/Hooks/Effects/Modals/useShowSecretSanta"; // Legacy
import useBasketProductsUpdate from "@/Hooks/Effects/Stores/useBasketProductsUpdate"; // Legacy
import useFavouritesDataChange from "@/Hooks/Effects/Stores/useFavouritesDataChange"; // Legacy
import useFatalError from "@/Hooks/Effects/Errors/useFatalError"; // Legacy

type Props = {
    fatalErrorMessage: string;
    user: User;
}

export const Effects = () => {
    /**
     * Чтобы важные изменения страницы фиксировались Яндекс Метрикой
     */
    usePageChangesForYaMetrica();

    /**
     * Если 500 ошибка
     */
    useFatalError();

    /**
     * Отправка user id в dataLayer (Задача № 5895)
     */
    useGlobalUserDataLayer();

    /**
     * Закрытие модальных окон
     */
    useCloseModalWindows();

    /**
     * Показываем окно с колесом фортуны
     */
    useShowWheelOfFortune();

    /**
     * Модальное окно "Продолжить в приложении"
     */
    useShowContinueApplication();

    /**
     * Модальное окно "Скидка на первый заказ"
     */
    useShowDiscountOnFirstOrder();

    /**
     * Модальное окно "Весенний календарь подарков"
     */
    useShowGiftCalendar();

    /**
     * Модальное окно "Тайный санта"
     */
    useShowSecretSanta();

    /**
     * обновление состояния товаров корзины
     */
    useBasketProductsUpdate();

    /**
     * обновление состояния товаров избранного
     */
    useFavouritesDataChange();

    /**
     * Добавляем класс для тега body
     */
    useBodyClass();

    return null;
}
